// Shared component styles. Preserve selector order, style values, and caller overrides.
export const TAB_VIEW_SIDEBAR_WIDTH = 392;
export const listPageStyles = {
  resolveShell: ({
    rightSidebar,
    shellSx
  }) => rightSidebar ? {
    ...(shellSx || {}),
    pt: 0
  } : shellSx,
  root: ({
    rootSx
  }) => ({
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    ...rootSx
  }),
  breadcrumb: () => ({
    minWidth: 0
  }),
  shell: ({
    resolvedShellSx
  }) => ({
    pb: 2,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    ...resolvedShellSx
  }),
  layout: ({
    layoutSx
  }) => ({
    display: "flex",
    gap: 4,
    alignItems: "flex-start",
    flexDirection: {
      xs: "column",
      md: "row"
    },
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    ...layoutSx
  }),
  contentColumn: ({
    leftColumnSx
  }) => ({
    flex: 1,
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "#fff",
    overflow: "hidden",
    ...leftColumnSx
  }),
  stats: ({
    statsWrapperSx
  }) => ({
    px: 0,
    pb: 2,
    ...statsWrapperSx
  }),
  content: ({
    contentWrapperSx
  }) => ({
    p: 0,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    ...contentWrapperSx
  }),
  sidebar: ({
    rightSidebarSx
  }) => ({
    width: {
      xs: "100%",
      md: TAB_VIEW_SIDEBAR_WIDTH
    },
    maxWidth: "100%",
    minWidth: 0,
    "& > *": {
      width: "100%",
      maxWidth: "100%"
    },
    "& > *:not(:last-child)": {
      marginBottom: "32px !important"
    },
    "& > *:last-child": {
      marginBottom: "0 !important"
    },
    ...rightSidebarSx
  })
};
